module.exports = __webpack_public_path__ + "static/media/laurensgroen.d752e293.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/laurensgroen.webp
// module id = 272
// module chunks = 0